import React, {useState, useEffect, useRef} from 'react';
import {AnimationSlideToggle} from '.';

// Filas de skeleton mientras se cargan las opciones
const SKELETON_ROWS = 4;

const DealershipCustomDropDown = ({items, label, isDisabled, selectedOption, onClickOption, initialValue, isLoading = false}) => {

    const [isOpen, setIsOpen] = useState(false);
    const modalRef = useRef()

    useEffect(() => {
        function handler(event) {
            if(!modalRef.current?.contains(event.target)) {
                setIsOpen(false)
            }
        }
        window.addEventListener('click', handler)
        return () => window.removeEventListener('click', handler)
    }, [])

    const handleClickOption = option => {
        onClickOption(option);
        setIsOpen(false);
    }

    // Si ya hay opciones cargadas (por ej. al reabrir el modal, que vuelve a pedir
    // los concesionarios) se muestran esas en vez de tapar la lista con el skeleton
    const showSkeleton = isLoading && !items?.length;

    return (
        <div className={"custom-dropdown" + (label ? " with-label " + label : "") + (isOpen ? " active" : "") + (isDisabled ? " disabled" : "")} ref={modalRef}>
            <label>{label}</label>
            <div className="selected" onClick={() => !isDisabled && setIsOpen(!isOpen)}>
                <div className="selected-option">{selectedOption?.name ? selectedOption.name : initialValue ? initialValue : "Seleccionar"}</div>
            </div>
            <AnimationSlideToggle isOpen={isOpen}>
                <ul>
                    {showSkeleton && Array.from({length: SKELETON_ROWS}).map((_, index) => (
                        <li key={`skeleton-${index}`} className="skeleton-option" aria-hidden="true">
                            <span className="skeleton-line skeleton-option__icon" />
                            <div>
                                <span className="skeleton-line skeleton-option__name" />
                                <span className="skeleton-line skeleton-option__address" />
                            </div>
                            <span className="skeleton-line skeleton-option__distance" />
                        </li>
                    ))}
                    {!showSkeleton && items && items.map(option => {
                        if (option?.id !== selectedOption?.id) {
                            return (
                                <li key={`option-${option.id}`} className={option.distance_km != null && "with-distance"} onClick={() => handleClickOption(option)}>
                                    {
                                        option.distance_km != null &&
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.99844 11.8084C8.22344 11.8084 6.77344 10.3667 6.77344 8.58337C6.77344 6.80003 8.22344 5.3667 9.99844 5.3667C11.7734 5.3667 13.2234 6.80837 13.2234 8.5917C13.2234 10.375 11.7734 11.8084 9.99844 11.8084ZM9.99844 6.6167C8.9151 6.6167 8.02344 7.50003 8.02344 8.5917C8.02344 9.68337 8.90677 10.5667 9.99844 10.5667C11.0901 10.5667 11.9734 9.68337 11.9734 8.5917C11.9734 7.50003 11.0818 6.6167 9.99844 6.6167Z" fill="#E30018"/>
                                        <path d="M10.0014 18.9666C8.76803 18.9666 7.52637 18.5 6.5597 17.575C4.10137 15.2083 1.3847 11.4333 2.4097 6.94163C3.3347 2.86663 6.89303 1.04163 10.0014 1.04163C10.0014 1.04163 10.0014 1.04163 10.0097 1.04163C13.118 1.04163 16.6764 2.86663 17.6014 6.94996C18.618 11.4416 15.9014 15.2083 13.443 17.575C12.4764 18.5 11.2347 18.9666 10.0014 18.9666ZM10.0014 2.29163C7.57637 2.29163 4.4597 3.58329 3.6347 7.21663C2.7347 11.1416 5.20137 14.525 7.4347 16.6666C8.87637 18.0583 11.1347 18.0583 12.5764 16.6666C14.8014 14.525 17.268 11.1416 16.3847 7.21663C15.5514 3.58329 12.4264 2.29163 10.0014 2.29163Z" fill="#E30018"/>
                                        </svg>
                                    }
                                    <div>
                                        <b>
                                            {option.name}
                                        </b>
                                        {option.address ? <span>{option.address}</span> : null }
                                    </div>
                                    {option.distance_km != null ?
                                    <span className="distance">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.37873 3.06667C1.91207 0.760003 5.3854 0.760003 5.91207 3.06667C6.2254 4.42 5.3654 5.56667 4.61874 6.28C4.07207 6.8 3.21207 6.79334 2.6654 6.28C1.9254 5.56667 1.0654 4.42 1.37873 3.06667Z" stroke="#5C5C5C" stroke-width="1.5"/>
                                    <path d="M10.0467 11.0667C10.58 8.76 14.0733 8.76 14.6067 11.0667C14.92 12.42 14.06 13.5667 13.3067 14.28C12.76 14.8 11.8933 14.7933 11.3467 14.28C10.5933 13.5667 9.73333 12.42 10.0467 11.0667Z" stroke="#5C5C5C" stroke-width="1.5"/>
                                    <path d="M8.0011 3.33337H9.78777C11.0211 3.33337 11.5944 4.86004 10.6678 5.67337L5.3411 10.3334C4.41444 11.14 4.98777 12.6667 6.21444 12.6667H8.0011" stroke="#5C5C5C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M3.65845 3.66671H3.66616" stroke="#5C5C5C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M12.3225 11.6667H12.3302" stroke="#5C5C5C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <p>
                                        {option.distance_km.toLocaleString("es-CL")} km
                                    </p>
                                    </span> : null }
                                </li>
                            )
                        }
                    })}
                </ul>
            </AnimationSlideToggle>
        </div>
    )
}

export default DealershipCustomDropDown;